module.exports = __webpack_public_path__ + "img/未标题-3-19.98de57d6.png";